import { writable } from 'svelte/store';

export const cognitoUserPoolStore = writable();
